import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "./utils/cn";

export type ClusterGap = "sm" | "md" | "lg" | "xl" | "2xl";
export type ClusterAlign = "start" | "center" | "end" | "baseline";
export type ClusterJustify = "start" | "between" | "end";

export interface ClusterProps extends HTMLAttributes<HTMLDivElement> {
  gap?: ClusterGap;
  align?: ClusterAlign;
  justify?: ClusterJustify;
  children?: ReactNode;
}

export const Cluster = ({
  gap = "md",
  align,
  justify,
  className,
  children,
  ...rest
}: ClusterProps) => (
  <div
    className={cn(
      "hui-cluster",
      `hui-cluster--gap-${gap}`,
      align && `hui-cluster--align-${align}`,
      justify && `hui-cluster--justify-${justify}`,
      className
    )}
    {...rest}
  >
    {children}
  </div>
);
